import LoginForm from '../views/app_pages/AuthLayout/Login';
import Register from '../views/app_pages/AuthLayout/Register';
import ForgotPassword from '../views/app_pages/AuthLayout/ForgotPassword';
import ResetPassword from '../views/app_pages/AuthLayout/ResetPassword';
import AuthLayout from '../views/layouts/AuthLayout';
import MainLayout from '../views/layouts/MainLayout';
import { useRoutes } from 'react-router-dom';
import Dashboard from '../views/app_pages/Dashboard';
import PageNotFound from '../views/errors/PageNotFound';
import AdminUsers from '../views/app_pages/AdminUser';
import AdminSettings from '../views/app_pages/AdminSettings';
import Merchant from '../views/app_pages/Merchant';
import Profile from '../views/app_pages/Profile';
import Temples from '../views/app_pages/Temples';
import BulkTemple from '../views/app_pages/BulkImport/Temple';
import BulkAccommodation from '../views/app_pages/BulkImport/Accommodation';
import Accommodation from '../views/app_pages/Accommodation';
import Region from '../views/app_pages/Region';
import PublicSettings from '../views/app_pages/PublicSettings';
import Payments from '../views/app_pages/Payment';
import BookingInvoices from '../views/app_pages/BookingInvoice';
import Customers from '../views/app_pages/Customer';

export default function Router() {
	const element = useRoutes(RouterConfig);
	return element;
}

const RouterConfig = [
	{
		element: <AuthLayout />,
		children: [
			{
				path: '/',
				element: <LoginForm />,
			},
			{
				path: '/login',
				element: <LoginForm />,
			},
			{
				path: '/Register',
				element: <Register />,
			},
			{
				path: '/forgot-password',
				element: <ForgotPassword />,
			},
			{
				path: '/reset-password',
				element: <ResetPassword />,
			},
		],
	},
	{
		element: <MainLayout />,
		children: [
			{
				path: '/dashboard',
				element: <Dashboard />,
			},
			{
				path: '/temples',
				element: <Temples />,
			},
			{
				path: '/users',
				element: <AdminUsers />,
			},
			{
				path: '/payments',
				element: <Payments />,
			},
			{
				path: '/customers',
				element: <Customers />,
			},
			{
				path: '/bookinginvoice',
				element: <BookingInvoices />,
			},
			{
				path: '/admin-settings',
				element: <AdminSettings />,
			},
			{
				path: '/merchant',
				element: <Merchant />,
			},
			{
				path: '/profile',
				element: <Profile />,
			},
			{
				path: 'bulk-import/temple',
				element: <BulkTemple />,
			},
			{
				path: 'bulk-import/accommodation',
				element: <BulkAccommodation />,
			},
			{
				path: '/accommodation',
				element: <Accommodation />,
			},
			{
				path: '/region',
				element: <Region />,
			},
			{
				path: '/public-settings',
				element: <PublicSettings />,
			},
		],
	},
	{
		path: '*',
		element: <PageNotFound />,
	},
];
